import { HERO_DISH_IMAGE } from "@/lib/constants";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-28 sm:pt-32 pb-16 sm:pb-24"
    >
      {/* soft floral accents */}
      <FloralBlob className="hidden md:block absolute -top-10 -left-10 w-72 opacity-50" />
      <FloralBlob className="hidden md:block absolute bottom-0 right-0 w-80 opacity-40 rotate-180" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 floatin">
          <span className="eyebrow left mb-5" data-testid="hero-eyebrow">
            <span className="font-script normal-case tracking-normal text-base text-[hsl(var(--rose-deep))]">
              ~ Orlando & Central Florida
            </span>
            Catering & Handcrafted Desserts
          </span>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[hsl(var(--brown))]"
          >
            Homestyle catering and{" "}
            <span className="italic text-[hsl(var(--rose-deep))]">
              handcrafted desserts
            </span>{" "}
            for{" "}
            <span className="font-script text-[hsl(var(--sage-deep))] text-5xl sm:text-6xl lg:text-7xl">
              meaningful
            </span>{" "}
            gatherings.
          </h1>

          <p
            data-testid="hero-sub"
            className="mt-6 max-w-xl text-base sm:text-lg text-[hsl(var(--brown-soft))] leading-relaxed"
          >
            Heritage Table Catering serves traditional flavors, multicultural
            comfort food, and beautifully prepared meals for families,
            churches, weddings, and events across Orlando &amp; Central Florida.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href="#quote"
              data-testid="hero-primary-cta"
              className="btn-pill btn-primary"
            >
              Request Catering Quote
              <span aria-hidden>→</span>
            </a>
            <a
              href="#traditions"
              data-testid="hero-secondary-cta"
              className="btn-pill btn-secondary"
            >
              View Our Food Traditions
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-[hsl(var(--brown-soft))]">
            <Bullet>Multicultural menus</Bullet>
            <Bullet>Family-style platters</Bullet>
            <Bullet>Wedding & church catering</Bullet>
            <Bullet>Handcrafted desserts</Bullet>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -inset-3 rounded-[2rem] bg-[hsl(var(--rose)/0.18)] -rotate-2" />
            <div className="absolute -inset-3 rounded-[2rem] bg-[hsl(var(--sage)/0.2)] rotate-2" />
            <div className="relative recipe-card p-3 sm:p-4 bg-[hsl(var(--cream))]">
              <div className="relative overflow-hidden rounded-[0.95rem]">
                <img
                  src={HERO_DISH_IMAGE}
                  alt="Signature catering dish — Heritage Table Catering"
                  className="w-full aspect-[4/5] object-cover"
                  data-testid="hero-dish-image"
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(180deg, transparent 55%, hsl(28 22% 16% / 0.55) 100%)",
                  }}
                />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="font-script text-2xl text-[hsl(var(--cream))]">
                    from our table to yours
                  </span>
                </div>
              </div>
              <div className="mt-5 flex items-center justify-center gap-2">
                <span className="h-px w-8 stitched-divider" />
                <span className="font-script text-xl text-[hsl(var(--rose-deep))]">
                  est. with love
                </span>
                <span className="h-px w-8 stitched-divider" />
              </div>
              <p className="mt-2 mb-1 text-center text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[hsl(var(--sage-deep))] font-semibold">
                Traditional flavors · Honest food
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Bullet({ children }) {
  return (
    <span className="inline-flex items-center gap-2">
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-[hsl(var(--rose-deep))]" />
      {children}
    </span>
  );
}

function FloralBlob({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <g fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path
          d="M50 220c40-60 100-80 160-50s90 90 60 130-110 30-160 0-90-50-60-80z"
          fill="hsl(4 38% 70% / 0.3)"
        />
        <path
          d="M120 140c20-30 60-30 80-10s10 60-20 70-70-30-60-60z"
          fill="hsl(100 14% 56% / 0.35)"
        />
        <circle cx="200" cy="200" r="14" fill="hsl(40 53% 54% / 0.7)" />
        <circle cx="170" cy="180" r="6" fill="hsl(4 42% 55% / 0.7)" />
        <circle cx="220" cy="180" r="6" fill="hsl(4 42% 55% / 0.7)" />
        <circle cx="190" cy="220" r="6" fill="hsl(4 42% 55% / 0.7)" />
        <circle cx="215" cy="220" r="6" fill="hsl(4 42% 55% / 0.7)" />
      </g>
    </svg>
  );
}
